var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],class:_vm.prefixCls,style:({
        'z-index': 2020 + this.tIndex
    }),attrs:{"data-transfer":true}},_vm._l((_vm.messages),function(message){return _c('MessageItem',{key:message.name,attrs:{"name":message.name,"type":message.type,"duration":message.duration,"closeable":message.closeable,"content":message.content}})}))}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/base/message/message.vue?vue&type=template&id=4a9f5a14&
// module id = 141
// module chunks = 0